import mime from 'mime';

import DocIcon from '@/assets/icons/filetypes/doc.svg?react';
import DocxIcon from '@/assets/icons/filetypes/docx.svg?react';
import PdfIcon from '@/assets/icons/filetypes/pdf.svg?react';
import PptIcon from '@/assets/icons/filetypes/ppt.svg?react';
import PptxIcon from '@/assets/icons/filetypes/pptx.svg?react';
import XlsIcon from '@/assets/icons/filetypes/xls.svg?react';
import XlsxIcon from '@/assets/icons/filetypes/xlsx.svg?react';

const ICONS: Record<string, React.FC> = {
  pdf: PdfIcon,
  doc: DocIcon,
  docx: DocxIcon,
  ppt: PptIcon,
  pptx: PptxIcon,
  xls: XlsIcon,
  xlsx: XlsxIcon,
};

interface Props extends React.SVGProps<SVGSVGElement> {
  type: string;
}

const FileTypeIcon: React.FC<Props> = ({ type, ...props }) => {
  const Icon = ICONS[mime.getExtension(type) as string];

  return <Icon {...props} />;
};

export default FileTypeIcon;
